import React, { Component } from 'react';
import { Edit, SimpleForm, TextInput} from 'react-admin';
import { AffiliateStatusOptionEditTitle } from './';

export default class AffiliateStatusOptionsEdit extends Component{
    render(){
        return(
            <Edit  title={<AffiliateStatusOptionEditTitle />} {...this.props}>
                <SimpleForm>
                    <TextInput source="name" />
                </SimpleForm>
            </Edit >
        )
    }
}